import { render, staticRenderFns } from "./EditServiceItemTable.vue?vue&type=template&id=35c357a4&scoped=true"
import script from "./EditServiceItemTable.vue?vue&type=script&lang=js"
export * from "./EditServiceItemTable.vue?vue&type=script&lang=js"
import style0 from "./EditServiceItemTable.vue?vue&type=style&index=0&id=35c357a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c357a4",
  null
  
)

export default component.exports